module.exports = __webpack_public_path__ + "media/images/niq-info-759fbe20daffa0b070a1fcd5bd6348cd.svg";